var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "PlanDayOrder", attrs: { dir: "rtl" } }, [
    _c("div", { staticClass: "day-header-box" }, [
      _c(
        "button",
        {
          staticClass: "day-header-arrow",
          attrs: { type: "button", disabled: !_vm.canGoPrevDay },
          on: { click: _vm.prevDay },
        },
        [_vm._v("‹")]
      ),
      _c("div", { staticClass: "day-header-info" }, [
        _c("div", { staticClass: "day-number-box" }, [
          _c("span", { staticClass: "day-number-num" }, [
            _vm._v(_vm._s(_vm.dayNumber)),
          ]),
        ]),
        _c("div", [
          _c("div", { staticClass: "day-label" }, [
            _vm._v(_vm._s(_vm.displayDate)),
          ]),
          _c("div", { staticClass: "day-name" }, [
            _vm._v(_vm._s(_vm.dayNameHebrew)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "day-header-progress" }, [
        _c("span", { staticClass: "day-progress-label" }, [
          _vm._v("משימות ביום"),
        ]),
        _c("span", { staticClass: "day-progress-count" }, [
          _vm._v(_vm._s(_vm.tasks.length)),
        ]),
      ]),
      _c("div", { staticClass: "day-header-progress" }, [
        _c("span", { staticClass: "day-progress-label" }, [_vm._v("סה״כ זמן")]),
        _c(
          "span",
          {
            staticClass: "day-progress-count",
            staticStyle: { color: "#17437A" },
          },
          [_vm._v(_vm._s(_vm.toHours(_vm.totalMinutes)))]
        ),
      ]),
      _c(
        "button",
        {
          staticClass: "day-header-arrow",
          attrs: { type: "button" },
          on: { click: _vm.nextDay },
        },
        [_vm._v("›")]
      ),
    ]),
    _c("div", { staticClass: "day-note-box" }, [
      _c("div", { staticClass: "day-note-head" }, [
        _c("span", { staticClass: "day-note-title" }, [_vm._v("הערת היום")]),
        _c(
          "div",
          { staticClass: "day-note-actions" },
          [
            !_vm.editingNote
              ? _c(
                  "button",
                  {
                    staticClass: "day-note-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.startEditNote },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.dayComments ? "ערוך" : "הוסף הערה") + " "
                    ),
                  ]
                )
              : [
                  _c(
                    "button",
                    {
                      staticClass: "day-note-btn",
                      attrs: { type: "button", disabled: _vm.savingNote },
                      on: { click: _vm.cancelEditNote },
                    },
                    [_vm._v("בטל")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "day-note-btn is-primary",
                      attrs: { type: "button", disabled: _vm.savingNote },
                      on: { click: _vm.saveNote },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.savingNote ? "שומר..." : "שמור") + " "
                      ),
                    ]
                  ),
                ],
          ],
          2
        ),
      ]),
      _vm.editingNote
        ? _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.noteDraft,
                expression: "noteDraft",
              },
            ],
            staticClass: "day-note-input",
            attrs: { rows: "3", placeholder: "הערה לאדמין עבור יום זה" },
            domProps: { value: _vm.noteDraft },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.noteDraft = $event.target.value
              },
            },
          })
        : _c(
            "p",
            {
              staticClass: "day-note-text",
              class: { "is-empty": !_vm.dayComments },
            },
            [_vm._v(" " + _vm._s(_vm.dayComments || "אין הערה ליום זה.") + " ")]
          ),
    ]),
    _c(
      "div",
      { staticClass: "tasks-list" },
      [
        _c("div", { staticClass: "tasks-list-head" }, [
          _c("span", { staticClass: "tasks-list-title" }, [
            _vm._v("סדר המשימות ביום"),
          ]),
          _c("span", { staticClass: "tasks-list-hint" }, [
            _vm._v(
              "הקלד מספר 1–" + _vm._s(_vm.tasks.length) + " או השתמש בחצים"
            ),
          ]),
        ]),
        _vm._l(_vm.tasks, function (task, i) {
          return _c("div", { key: task.id, staticClass: "task-card" }, [
            _c(
              "div",
              { staticClass: "task-card-main" },
              [
                _c("div", { staticClass: "task-body" }, [
                  _c("div", { staticClass: "task-title-row" }, [
                    task.subjectName
                      ? _c(
                          "span",
                          {
                            staticClass: "task-subject-chip",
                            style: { background: _vm.subjectColor(task) },
                          },
                          [_vm._v(" " + _vm._s(task.subjectName) + " ")]
                        )
                      : _vm._e(),
                    _c("span", { staticClass: "task-title" }, [
                      _vm._v(_vm._s(task.name)),
                    ]),
                  ]),
                  _c("div", { staticClass: "task-meta" }, [
                    task.entityName
                      ? _c("span", [_vm._v(_vm._s(task.entityName))])
                      : _vm._e(),
                    task.entityName
                      ? _c("span", { staticClass: "sep" }, [_vm._v("·")])
                      : _vm._e(),
                    _c("span", [_vm._v(_vm._s(task.typeName))]),
                    _c("span", { staticClass: "sep" }, [_vm._v("·")]),
                    _c("span", [
                      _vm._v(_vm._s(_vm.timeWindowLabel(task.timeWindow))),
                    ]),
                    _c("span", { staticClass: "sep" }, [_vm._v("·")]),
                    _c("span", { staticClass: "muted" }, [
                      _vm._v("#" + _vm._s(task.taskId)),
                    ]),
                  ]),
                ]),
                task.taskComments
                  ? _c(
                      "button",
                      {
                        staticClass: "task-comments-toggle",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.toggleTaskComments(task.id)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "task-comments-text" }, [
                          _vm._v("הערות"),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "task-comments-arrow",
                            class: { open: _vm.isCommentsOpen(task.id) },
                          },
                          [_vm._v("▼")]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "b-tooltip",
                  {
                    attrs: {
                      label: _vm.durationTooltip(task),
                      position: "is-top",
                      multilined: "",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "task-duration",
                        class: { "is-overridden": task.isDurationOverridden },
                      },
                      [
                        _c("span", { staticClass: "num" }, [
                          _vm._v(_vm._s(task.durationMinutes || "—")),
                        ]),
                        _c("span", { staticClass: "unit" }, [_vm._v("דק'")]),
                        task.isDurationOverridden
                          ? _c("span", { staticClass: "ovr" }, [
                              _vm._v("מותאם"),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "order-control" }, [
                  _c("input", {
                    staticClass: "order-input",
                    attrs: { type: "number", min: "1", max: _vm.tasks.length },
                    domProps: { value: _vm.draftFor(task, i) },
                    on: {
                      input: function ($event) {
                        return _vm.onDraft(task.id, $event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.commitDraft(task.id)
                      },
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return $event.target.blur()
                      },
                    },
                  }),
                  _c("div", { staticClass: "order-arrows" }, [
                    _c(
                      "button",
                      {
                        attrs: { type: "button", disabled: i === 0 },
                        on: {
                          click: function ($event) {
                            return _vm.move(task.id, i)
                          },
                        },
                      },
                      [_vm._v("▲")]
                    ),
                    _c(
                      "button",
                      {
                        attrs: {
                          type: "button",
                          disabled: i === _vm.tasks.length - 1,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.move(task.id, i + 2)
                          },
                        },
                      },
                      [_vm._v("▼")]
                    ),
                  ]),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "task-unassign",
                    attrs: {
                      type: "button",
                      title: "בטל שיוך",
                      disabled: _vm.unassigningId === task.id,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.unassign(task)
                      },
                    },
                  },
                  [
                    _c("b-icon", {
                      attrs: { icon: "delete", size: "is-small" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            task.taskComments && _vm.isCommentsOpen(task.id)
              ? _c("div", { staticClass: "task-comments-expanded" }, [
                  _vm._v(" " + _vm._s(task.taskComments) + " "),
                ])
              : _vm._e(),
          ])
        }),
        !_vm.tasks.length && !_vm.loading
          ? _c("div", { staticClass: "empty-state" }, [
              _c("p", [_vm._v("אין משימות בתאריך זה.")]),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm.isDirty
      ? _c("div", { staticClass: "pdo-savebar" }, [
          _c("span", [_vm._v("הסדר שונה ולא נשמר")]),
          _c(
            "div",
            [
              _c("b-button", {
                attrs: { label: "בטל שינויים" },
                on: { click: _vm.reset },
              }),
              _c("b-button", {
                attrs: {
                  type: "is-primary",
                  label: "שמור סדר",
                  loading: _vm.saving,
                },
                on: { click: _vm.save },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }